/** @jsx h */
/** @jsxFrag Fragment */
import { Fragment, h } from "preact";
import { DatUIBaseProps } from "./dat.tsx";
import { cx } from "@utils/utils";

export interface DatStringProps extends DatUIBaseProps {
  onChange: (v: string) => void;
  value?: string;
}
export function DatString(props: DatStringProps) {
  const labelWidth = "40%";
  const labelText = props.label || "DefaultLabel";

  return (
    <li class={cx("cr", "string", props.class)} style={props.style}>
      <label>
        <span class="label-text" style={{ width: labelWidth }}>
          {labelText}
        </span>
        <input
          style={{ width: `calc(100% - ${labelWidth})` }}
          type="text"
          value={props.value}
          onChange={(e) => {
            props.onChange((e.target! as HTMLInputElement).value);
          }}
        />
      </label>
    </li>
  );
}
